/**
 * Token相关
 */
import mainVue from '../main'
import { Notification } from 'element-ui'
// api
import { getAccountRequest } from '../api/common'

const TokenKey = 'Admin-Token'

const SessionIdKey = 'Session-Id-Key'

export function getToken () {
  return localStorage.getItem(TokenKey)
}

export function setToken (token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken () {
  return localStorage.removeItem(TokenKey)
}

export function getSessionId () {
  const sessionId = localStorage.getItem(SessionIdKey)
  if (sessionId) {
    return sessionId
  } else {
    // 无效sessionId，返回登录页面
    Notification({
      title: '登录失效',
      type: 'error',
      message: '请重新登录'
    })
    setTimeout(() => {
      mainVue.$router.replace('/login?1').catch(error => error)
    }, 500)
  }
}

export function setSessionId (value) {
  return localStorage.setItem(SessionIdKey, value)
}

export function removeSessionId () {
  return localStorage.removeItem(SessionIdKey)
}

/**
 * token检查
 * 方法进行判断，session内有无token，再判断其token是否有效
 * 根据结果跳转页面
 */
export function checkToken () {
  if (getToken()) {
    // 有token
    getAccountRequest().then(data => {
      if (data.Code === 1) {
        // token有效
        if (mainVue.$route.name === 'login' || mainVue.$route.name === 'welcome') {
          Notification({
            title: '自动登录成功',
            type: 'success'
          })
          // 直接跳转到dashboard
          setTimeout(() => {
            mainVue.$router.replace('/dashboard')
          }, 500)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js